


import React from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import "./groupindividual.css";  // renamed for clarity
import Overview from "./overview";
import Members from "./member";
import Transactions from "./transcations";
import Attendance from "./attendence";
import GroupNav from "./groupnav";
import AttendancePagefull from "../fullattendence";

export default function ClassDashboard() {
  const { groupid } = useParams(); // from /group-details/:groupid/*

  return (
    <div className="indigroup_app">
      <main className="indigroup_main">
        {/* ✅ Navigation Tabs */}
        <GroupNav />

        {/* Sub-routes */}
        <Routes>
          <Route path="/" element={<Navigate to="overview" replace />} />
          <Route path="/overview" element={<Overview groupCode={groupid} />} />
          <Route path="/members" element={<Members groupCode={groupid} />} />
          <Route path="/transactions" element={<Transactions groupCode={groupid} />} />
          <Route path="/attendance" element={<Attendance groupCode={groupid} />} />
             <Route path="/fullattend" element={< AttendancePagefull />} />
        </Routes>
      </main>
    </div>
  );
}
